export const STAFF_LOGIN_ROLES = ['admin', 'instructor', 'reception', 'finance'];

export const normalizeRole = (role) => {
  const key = String(role || '').trim().toLowerCase();
  if (key === 'admin') return 'admin';
  if (key === 'instructor') return 'instructor';
  if (key === 'finance') return 'finance';
  if (key === 'reception') return 'reception';
  return 'reception';
};

export const formatRoleLabel = (role) => {
  const normalized = normalizeRole(role);
  if (normalized === 'admin') return 'Admin';
  if (normalized === 'instructor') return 'Instructor';
  if (normalized === 'finance') return 'Finance';
  return 'Reception';
};

export const getHomePathForRole = (role) => {
  const normalized = normalizeRole(role);
  if (normalized === 'admin') return '/dashboard';
  if (normalized === 'instructor') return '/instructor';
  if (normalized === 'finance') return '/finance/payments';
  if (normalized === 'reception') return '/reception/students';
  return '/login';
};

export const canSignIn = (role) => STAFF_LOGIN_ROLES.includes(normalizeRole(role));
